import React from "react";
import Link from "gatsby-link";
import { endSlash } from "../../util/helperFunctions";

const ButtonText = ({ className, route, text = "Learn More" }) => {
  return (
    <Link to={endSlash(route)} className={`${className} h-6 ttu mb0 tc`}>
      {text}
    </Link>
  );
};

export default ButtonText;



// WEBPACK FOOTER //
// ./src/components/Buttons/ButtonText.js